<script setup>
import { defineProps, defineEmits, ref } from 'vue';
import { computed } from 'vue';
import { FILE_ICONS } from './constants';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  accept: { type: Array, default: () => [] },
});

const emit = defineEmits(['change']);
const selectedFile = ref(null);

const handleFileChange = event => {
  const files = event.target.files;
  if (files.length > 0) {
    emit('change', files[0]);
    selectedFile.value = files[0];
  }
};

const selectedFileIcon = computed(() => {
  if (!selectedFile.value) return 'i-ri-file-line';
  const fileExtension = selectedFile.value.name.split('.').pop().toLowerCase();
  return FILE_ICONS[fileExtension] || 'i-ri-file-line';
});

const acceptFormats = computed(() => {
  return props.accept.length > 0 ? props.accept.join(',') : '*';
});

const acceptMessage = computed(() => {
  return props.accept.length > 0 ? props.accept.join(', ') : 'Any format';
});
</script>

<template>
  <div
    class="relative flex overflow-auto border-dashed border-2 border-n-slate-6 rounded-lg items-center cursor-pointer w-full hover:bg-n-slate-2 active:bg-n-slate-3 transition-colors"
  >
    <div
      v-if="selectedFile"
      class="flex flex-row justify-start items-center text-xs text-n-slate-11 p-4 py-2"
    >
      <Icon :icon="selectedFileIcon" class="text-n-slate-11 text-3xl me-3" />
      <div>
        <p class="text-sm text-n-slate-11 mb-0">
          {{ selectedFile.name }}
        </p>
        <p class="text-xs text-n-slate-11">
          {{ `${(selectedFile.size / 1024).toFixed(2)} KB` }}
        </p>
      </div>
    </div>
    <div v-else class="py-4 justify-center items-center text-center w-full">
      <Icon
        icon="i-lucide-cloud-upload"
        class="text-n-slate-11 text-3xl my-3"
      />
      <p class="text-sm text-n-slate-11 ml-2">
        {{ $t('COMPONENTS.FILE_UPLOAD.DRAG_DROP') }}
      </p>
      <p class="text-xs text-n-slate-11">
        {{
          $t('COMPONENTS.FILE_UPLOAD.ACCEPTED_FORMATS', {
            formats: acceptMessage,
          })
        }}
      </p>
    </div>
    <input
      :accept="acceptFormats"
      type="file"
      data-testid="file-upload-input"
      class="absolute inset-0 cursor-pointer m-0 w-full h-full opacity-0"
      @change="handleFileChange"
    />
  </div>
</template>
